import { Text } from "../Text"
import styles from "./Kbd.module.css"

interface Props {
  /**
   * The keyboard key or keys this component should display.
   * Note that "mod" is a special value meaning whichever is the mod key for OSX or Windows/Linux systems.
   */
  value: string | string[]
}

/**
 * Represents a span of inline text denoting textual user input from a keyboard.
 */
export function Kbd(props: Props) {
  const { value } = props

  const keys = (typeof value === "string" ? [value] : value).map((key) => {
    if (key === "mod") return getModKey()
    return key.toUpperCase()
  })

  return (
    <span className={styles.kbd}>
      {keys.map((key) => (
        <kbd key={key} className={styles.kbdItem}>
          <Text color="grey11">{key}</Text>
        </kbd>
      ))}
    </span>
  )
}

function getModKey() {
  const isMac = navigator.userAgent.includes("Mac")
  return isMac ? "⌘" : "Ctrl"
}
